<template>
    <Form
        :tenant-setting="tenantSetting"
        :electronic-invoice-providers="electronicInvoiceProviders"
        :electronic-invoicing-types-pagero="electronicInvoicingTypesPagero"
        :electronic-invoicing-types-payex360="electronicInvoicingTypesPayex360"
        :vat-id-check-types="vatIdCheckTypes"
        :vat-id-check-type-default="vatIdCheckTypeDefault"
        :sepa-direct-debit-pain-versions="sepaDirectDebitPainVersions"
        :business-incident-types="businessIncidentTypes"
        :currency-code="currencyCode"
        :currency-symbol="currencySymbol"
        :electronic-invoice-operators="electronicInvoiceOperators"
        :available-payment-methods="availablePaymentMethods"
        :errors="errors"
        @form-submitted="submitData"
    />
</template>

<script>
import Form from '~@/Components/Settings/TenantSettings/Form'

export default {
    name: 'TenantSettingsCreate',
    components: {
        Form
    },
    props: {
        tenantSetting: {
            type: Object,
            default () {
                return {}
            }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        vatIdCheckTypes: {
            type: Array,
            default: () => { return [] }
        },
        leadDayForInvoiceVatIdCheckDefault: {
            type: Number,
            default: () => { return 14 }
        },
        vatIdCheckTypeDefault: {
            type: String,
            default: () => { return 'do_not_check' }
        },
        electronicInvoiceProviders: {
            type: Array,
            default: () => { return [] }
        },
        electronicInvoicingTypesPagero: {
            type: Array,
            default: () => { return [] }
        },
        electronicInvoicingTypesPayex360: {
            type: Array,
            default: () => { return [] }
        },
        sepaDirectDebitPainVersions: {
            type: Array,
            default: () => { return [] }
        },
        businessIncidentTypes: {
            type: Array,
            default: () => { return [] }
        },
        currencyCode: {
            type: Array,
            default: () => { return [] }
        },
        currencySymbol: {
            type: Array,
            default: () => { return [] }
        },
        electronicInvoiceOperators: {
            type: Array,
            default: () => { return [] }
        },
        availablePaymentMethods: {
            type: Array,
            default: () => { return [] }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.tenant-settings.store'))
        }
    }
}
</script>
